"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticMap = void 0;
const _1 = require(".");
class StaticMap extends _1.Service {
    constructor(onemap) {
        super(onemap, 'staticmap');
    }
    getStaticImageUri(req) {
        const newReq = req;
        if (newReq.polygons) {
            newReq.polygons = newReq.polygons.map((polygon) => `${JSON.stringify(polygon.points)}:${polygon.color.join(',')}`).join('|');
        }
        if (newReq.lines) {
            newReq.lines = newReq.lines.map((line) => `${JSON.stringify(line.points)}:${line.color.join(',')}:${line.thickness}`).join('|');
        }
        if (newReq.points) {
            newReq.points = newReq.points.map((point) => `[${point.point.join(',')},"${point.color.join(',')}","${point.label}"]`).join('|');
        }
        if (newReq.color) {
            newReq.color = newReq.color.join(',');
        }
        if (newReq.fillColor) {
            newReq.fillColor = newReq.fillColor.join(',');
        }
        return this.getCommonApiUri('getStaticImage', newReq);
    }
}
exports.StaticMap = StaticMap;
